module.exports = __webpack_public_path__ + "img/20180815_150609_102.622bffb9.jpg";